import { call, put, select, take } from 'redux-saga/effects';

import { CREATE_HIGHLIGHT, CREATE_NOTETEXT, UPDATE_HIGHLIGHT } from './actions';


function* create() {
  while (true) {
    let { data:selectedHighlight } = yield take(CREATE_NOTETEXT);

    const { id, markerId, noteText } = selectedHighlight;
    let _noteText = noteText;
    const { autoSaveNoteText } = yield select(state => state.noteslat);

    if (autoSaveNoteText) {
      _noteText = autoSaveNoteText;
    }

    selectedHighlight = { ...selectedHighlight, noteText: _noteText };

    if (id) {
      yield put({ type: UPDATE_HIGHLIGHT, data: { markerId, selectedHighlight } });
    } else {
      const noteText = selectedHighlight.noteText;
      yield put({ type: CREATE_HIGHLIGHT, data: { markerId, noteText } });
    }
  }
}


export default create;
